import { ShoppingCartProduct } from '@api/ShoppingCart/ShoppingCart';

// ============================================================================
// Línea de orden v2 (catálogo 2.0) — plan §3.3. MISMA colección `orders` y mismo
// campo `products[]`: una orden trae líneas v1 (ShoppingCartProduct, snapshot
// completo del product legacy) O líneas v2 (mini-snapshot del dish + modifiers
// con snapshots de texto — el ticket nunca depende de hidratación).
// CLAVE de compatibilidad: `cost` = TOTAL de línea (misma semántica que el POS
// actual) → getEarnedPoints y el rebuild de puntos NO se tocan.
// ============================================================================

export interface OrderLineModifier {
    groupId: string;
    // Renglón EXACTO del producto que se eligió (`Dish.modifierGroups[].instanceId`):
    // un producto puede traer el mismo grupo varias veces ("Queso — Hamburguesa 1/2").
    // Ausente en líneas creadas antes de las instancias → se resuelve por groupId.
    groupInstanceId?: string;
    groupName: string; // snapshot de texto (la etiqueta del renglón si la tiene)
    optionId: string;
    optionName: string; // snapshot de texto, SIN precio incrustado
    quantity: number;
    extraCost: number; // unitario por selección (0 = incluida en el precio)
}

export interface OrderLineRemovedIngredient {
    inputId: string;
    name: string; // snapshot de texto: "sin cebolla" explícito
}

export interface OrderLineV2 {
    // Mini-snapshot del dish (adiós al doc completo embebido de v1)
    product: {
        id: string;
        name: string;
        cost: number; // PRECIO base del dish
        productCategoryId: string;
    };
    quantity: number;
    takeAway: boolean;
    note: string;
    modifiers: OrderLineModifier[];
    removedIngredients: OrderLineRemovedIngredient[];
    unitPrice: number; // dish.cost + Σ modifiers (extraCost × quantity)
    cost: number; // TOTAL de línea = unitPrice × quantity
    schemaVersion: 2;
}

export type OrderLine = ShoppingCartProduct | OrderLineV2;

export const isOrderLineV2 = (line: OrderLine): line is OrderLineV2 =>
    (line as OrderLineV2)?.schemaVersion === 2;
